
export const setStorage = (key, value) => {
  if (value) {
    localStorage.setItem(key, value);
  } else {
    localStorage.removeItem(key);
  }
}

export const getStorage = (key) => {
  return localStorage.getItem(key);
}

export const getItem = (label, key, icon, children, type, disabled) => ({
  key,
  icon,
  children,
  label,
  type,
  disabled,
  title: label,
});

export const getPromo = (promo) => {
  promo = promo || "";
  const match = promo.match(/\d+/);
  return (match ? (100 - parseInt(match[0])) : 100) / 100;
}